export default __webpack_public_path__ + "static/media/gif-icon.60eca86d.gif";